var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Output, EventEmitter } from '@angular/core';
import { BuildStatus } from '../../../../enums/build-status';
import { WorkflowService } from '../../../../services/workload/workflow.service';
var StatusSummaryComponent = /** @class */ (function () {
    function StatusSummaryComponent(workflowService) {
        this.workflowService = workflowService;
        this.statusFilter = new EventEmitter();
        this.selectedState = null;
        this.viewModel = {
            pots: {
                new: {
                    status: BuildStatus.ReadyToBuild,
                    count: 0,
                    boundaries: {
                        low: 9,
                        mid: 10,
                        top: 20
                    }
                },
                research: {
                    status: BuildStatus.Research,
                    count: 0,
                    boundaries: {
                        low: 4,
                        mid: 5,
                        top: 10
                    }
                },
                input: {
                    status: BuildStatus.Input,
                    count: 0,
                    boundaries: {
                        low: 4,
                        mid: 9,
                        top: 10
                    }
                },
                comparison: {
                    status: BuildStatus.Comparison,
                    count: 0,
                    boundaries: {
                        low: 2,
                        mid: 3,
                        top: 6
                    }
                },
                approval: {
                    status: BuildStatus.Approval,
                    count: 0,
                    boundaries: {
                        low: 1000,
                        mid: 1000,
                        top: 1000
                    }
                },
                amend: {
                    status: BuildStatus.Amend,
                    count: 0,
                    boundaries: {
                        low: 1,
                        mid: 2,
                        top: 4
                    }
                },
                live: {
                    status: BuildStatus.Live,
                    count: 0,
                    boundaries: {
                        low: 0,
                        mid: 0,
                        top: 1
                    }
                },
                complete: {
                    status: BuildStatus.Complete,
                    count: 0,
                    boundaries: {
                        low: 0,
                        mid: 0,
                        top: 1
                    }
                }
            }
        };
    }
    StatusSummaryComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.workflowService.getStatusPotsConfiguration().subscribe(function (config) {
                            _this.viewModel.pots = config;
                            _this.loadRequests();
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StatusSummaryComponent.prototype.calculatePotStatus = function (pot) {
        var result = 'pot ';
        if (pot.count >= pot.boundaries.top)
            result += 'pot-danger';
        else if (pot.count >= pot.boundaries.mid && pot.count < pot.boundaries.top)
            result += 'pot-warning';
        else
            result += 'pot-success';
        return result;
    };
    StatusSummaryComponent.prototype.selectStatusPot = function (status) {
        this.selectedState = status;
        var command = {
            status: status,
            page: 0
        };
        this.statusFilter.emit(command);
    };
    StatusSummaryComponent.prototype.isStateSelected = function (state) {
        return this.selectedState === state;
    };
    StatusSummaryComponent.prototype.loadRequests = function () {
        var _this = this;
        var statesToLoad = [
            BuildStatus.ReadyToBuild,
            BuildStatus.Research,
            BuildStatus.Input,
            BuildStatus.Comparison,
            BuildStatus.Approval,
            BuildStatus.Amend,
            BuildStatus.Live,
            BuildStatus.Complete
        ];
        statesToLoad.map(function (state) {
            _this.workflowService.getTotalByStatus(state).toPromise().then(function (count) {
                switch (state) {
                    case BuildStatus.ReadyToBuild:
                        {
                            _this.viewModel.pots.new.count = count;
                            break;
                        }
                    case BuildStatus.Research:
                        {
                            _this.viewModel.pots.research.count = count;
                            break;
                        }
                    case BuildStatus.Input:
                        {
                            _this.viewModel.pots.input.count = count;
                            break;
                        }
                    case BuildStatus.Comparison:
                        {
                            _this.viewModel.pots.comparison.count = count;
                            break;
                        }
                    case BuildStatus.Approval:
                        {
                            _this.viewModel.pots.approval.count = count;
                            break;
                        }
                    case BuildStatus.Amend:
                        {
                            _this.viewModel.pots.amend.count = count;
                            break;
                        }
                    case BuildStatus.Live:
                        {
                            _this.viewModel.pots.live.count = count;
                            break;
                        }
                    case BuildStatus.Complete:
                        {
                            _this.viewModel.pots.complete.count = count;
                            break;
                        }
                }
            });
        });
    };
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], StatusSummaryComponent.prototype, "statusFilter", void 0);
    StatusSummaryComponent = __decorate([
        Component({
            selector: 'status-summary',
            template: require('./status-summary.component.html'),
            styles: [require('./status-summary.component.scss')]
        }),
        __metadata("design:paramtypes", [WorkflowService])
    ], StatusSummaryComponent);
    return StatusSummaryComponent;
}());
export { StatusSummaryComponent };
//# sourceMappingURL=data:application/json;base64,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